import styled from "styled-components";

export const Box = styled.div`
    position: absolute;
    width: 167px;
    height: 96px;
    display: flex;
    flex-direction: column;
    background: var(--tooltip-primary-bg-color, rgba(255, 255, 255, 1));
    border-radius: var(--tooltip-m-border-radius, 8px);
    padding: 12px;
    box-shadow: var(--tooltip-primary-shadow);

    &::before,
    &::after {
        content: "";
        position: absolute;
        bottom: -6px;
        left: var(--arrow-x, 50%);
        transform: translateX(-50%);
        border-left: 6px solid transparent;
        border-right: 6px solid transparent;
        border-top: 6px solid #ffffff;
    }
    &::after {
        bottom: -5px;
    }
`;
export const TooltipDateRow = styled.h4`
    color: var(--fg-muted, rgba(16, 24, 40, 0.55));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
    margin-bottom: 8px;
`

export const TooltipDataColRow = styled.div`
    display: flex;
    justify-content: space-between;
`

export const TooltipDataCol = styled.div`
    display: flex;
    flex-direction: column;
    gap: 2px;
    margin-top: auto;
`

export const TooltipDataColTitle = styled.h5`
    color: var(--fg-soft, rgba(16, 24, 40, 0.75));
    font-size: 12px;
    font-weight: 400;
    line-height: 16px;
`

export const TooltipDataColValue = styled.p`
    color: var(--fg-default, rgba(16, 24, 40, 1));

    display: flex;
    align-items: flex-end;
    gap: 4px;

    font-size: 14px;
    font-weight: 500;
    line-height: 16px;
    
    strong {
        font-size: 16px;
        font-weight: 700;
        line-height: 20px;
    }
    
    span {
        padding-bottom: 2px;
    }
`